( function ( $ ) {
    $( 'a.js-category-filter' ).each( function () {
		var element = $( this );

		// Get departent id and prepare data
		var categoryId = element.data( 'id' );
		var data = { category: [categoryId] };

		// Generate hash
		hash = CryptoJS.AES.encrypt( JSON.stringify( data ), 'betsson' ).toString();

		// Update link
		var baseURL = element.data( 'baseUrl' );
		element.prop( 'href', baseURL + '#' + hash );
	} );

	$( '.category-multiple' ).change( function () {
        $('.department-multiple').html('');
        //$('.location-multiple').html('');
        var category = new Array();
        $(this).find("option:selected").each(function() {
            category.push( $(this).val() );
        });

        $(this).on('select2:select', function (e) {
            // this will remove other categories and retain all only
            if(e.params.data.id == 'all') {
                $(this).val('all').trigger("change");
            } else {
                if(category.indexOf("all") == 0) {
                    var filtered = category.filter(function(value, index, arr) { 
                        return value != 'all';
                    });
                    category = filtered;
                    $(this).val(category).trigger("change");
                }
            }
        });

        // window.departmentDropdown(category);
       // window.locationDropdown(category, '', '');
    } );

    $( '.department-multiple' ).change( function () {
        var category = new Array();
        var department = new Array();
        // category
        $('.category-multiple').find("option:selected").each(function() {
            category.push( $(this).val() );
        });
        // department
        $(this).find("option:selected").each(function() {
            department.push( $(this).val() );
        });

        //window.locationDropdown(category, department, '');
    } );

    // window.departmentDropdown = function(jobData) {
    //     var category = jobData;
    //     // use jobData as category if jobData.category is undefined
    //     if(jobData.category != undefined) {
    //         category = jobData.category;
    //     }

    //     $.ajax( {
    //         url: '/wp-admin/admin-ajax.php',
    //         data: {
    //             action: 'get_department_dropdown',
    //             category: category,
    //         },
    //         method: 'get',
    //         dataType: 'json',
    //         beforeSend: function () {
    //             $('.department-multiple').attr('disabled', true);
    //             $('.department-multiple').select2({
    //                 allowClear: true,
    //                 placeholder: {
    //                     id: 0,
    //                     text: 'Loading. . .'
    //                 }
    //             });
    //         },
    //         success: function ( result ) {
    //             $('.department-multiple').attr('disabled', false);
    //             $('.department-multiple').addClass('has-data');
    //             $('.department-multiple').html('').select2({data: result.rows});

    //             if(jobData.category != undefined) {
    //                 var departmentNames = [];
    //                 $( '.js-jobs-search-form' ).find( '[name="departments[]"] option' ).prop( 'selected', false );
    //                 jobData.departments.forEach( function ( departmentId ) {
    //                     var items = $( '.js-jobs-search-form' ).find( '[name="departments[]"] option[value=' + departmentId + ']' );
    //                     items.prop( 'selected', true );

    //                     departmentNames.push( $( items[0] ).text() );
    //                 } );
    //                 $( '.js-jobs-search-form' ).find( '[name="departments[]"]' ).trigger( 'change' );
    //                 $( '#subscribe-modal' ).find( '.js-modal-departments' ).val( departmentNames.join( ',' ) );

    //                 window.locationDropdown(jobData.category, jobData.departments, jobData.locations);
    //             }
    //         },
    //         error: function ( result ) {
    //             console.log( result );
    //         }
    //     } );
    // };

    // window.locationDropdown = function(category, department, locations) {
    //     $.ajax( {
    //         url: '/wp-admin/admin-ajax.php',
    //         data: {
    //             action: 'get_hub_dropdown',
    //             category: category,
    //             department: department,
    //         },
    //         method: 'get',
    //         dataType: 'json',
    //         beforeSend: function () {
    //             $('.location-multiple').attr('disabled', true);
    //             $('.location-multiple').select2({
    //                 allowClear: true,
    //                 placeholder: {
    //                     id: 0,
    //                     text: 'Loading. . .'
    //                 }
    //             });
    //         },
    //         success: function ( result ) {
    //             $('.location-multiple').attr('disabled', false);
    //             $('.location-multiple').html('').select2({data: result.rows});

    //             if(locations != '') {
    //                 var locationNames = [];
	// 				$( '.js-jobs-search-form' ).find( '[name="locations[]"] option' ).prop( 'selected', false );
	// 				locations.forEach( function ( locationId ) {
	// 					var items = $( '.js-jobs-search-form' ).find( '[name="locations[]"] option[value=' + locationId + ']' );
	// 					items.prop( 'selected', true );

	// 					locationNames.push( $( items[0] ).text() );
	// 				} );
	// 				$( '.js-jobs-search-form' ).find( '[name="locations[]"]' ).trigger( 'change' );

	// 				$( '#subscribe-modal' ).find( '.js-modal-locations' ).val( locationNames.join( ',' ) );
    //             }
    //         },
    //         error: function ( result ) {
    //             console.log( result );
    //         }
    //     } );
    // };
} )( jQuery );